export default {
    'add-new-role': 'إضافة دور جديد',
    'permissions': 'الصلاحيات',
    'please-select-a-role': 'رجاءاَ اختر الدور الوظيفي',
    'job-title': 'المنصب الوظيفي',
    'manager': 'المدير',
    'read': 'قراءة',
    'action': 'تعديل / إضافة',
    'noThing': 'لا شيء'
}